import * as React from 'react';
import { ChatLayout } from '../../../components/chat-layout';
import { HeaderBackButton } from '../../../components/header-back-button';
import { OperatorInfoContent } from './content';
import { OperatorInfoFooter } from './footer';

const Info = () => (
  <ChatLayout
    header={<HeaderBackButton />}
    content={<OperatorInfoContent />}
    footer={<OperatorInfoFooter />}
  />
);

export default Info;
